import { useState, useEffect } from "react"
import TableStyle from "components/Options/TableStyle"
import { useSelector, useDispatch } from "react-redux"
import { updateSelectedRows } from "redux/warehouse/warehouseSlice"
import {
    scheduledPickupColor,
    onDockColor,
    makeNiceDate,
    OrderHistory,
    isOrderAPartialableByBusNamingConvention,
} from "../helpers"
import { isOrderABusByNamingConvention } from "components/Orders/helpers"
import { OrderLoadUnloadUtility } from "../modals/LoadConfirmation"
import { LabelPrinter } from "../modals/LabelPrint"
import InventoryScanner from "../modals/InventoryScanner"
import { BOLPrinter } from "../modals/PrintBOL"
import { updateWarehouseData } from "redux/warehouse/warehouseSlice"
import { setShowReduxModal } from "redux/warehouse/warehouseSlice"
import { PartialTypeRowSignal } from "./partial"
import { modifyOrder } from "components/Apis/orders"

const WasOrderLinePartialized = (order) => {
    return order.was_order_line_partialized
}

export const OrderNotes = ({ order }) => {
    const [notes, setNotes] = useState(order.notes || "");

    const handleBlur = (e) => {
        if (e.target.value === notes) return;
        setNotes(e.target.value);
        modifyOrder({
            id: order.id,
            notes: e.target.value,
        });
    };

    return (
        <>
            <input
                type='text'
                className='form-control input notesInput'
                placeholder="Order Notes"
                defaultValue={notes}
                onBlur={handleBlur}
            />
            <OrderHistory row={order} />
        </>
    );
};

const OrderRow = ({ order }) => {
    const dispatch = useDispatch()
    const display = useSelector((state) => state.warehouse.display)
    const warehouse = useSelector((state) => state.warehouse.warehouse)

    return (
        <>
            <tr
                className={`order-row bus-class-${isOrderABusByNamingConvention(order)}`}
                key={`order-tr-${order.id}`}
            >
                {display === "Incoming" && (
                    <td className="inbound-column">
                        {order.inbound} {order.master_mx_carrier}
                    </td>
                )}
                {display === "Incoming" && warehouse === "Laredo" && (
                    <td className="trailer-column">{order.master_trailer_placas}</td>
                )}
                <td
                    className="dock-column"
                    style={
                        display === "Incoming"
                            ? onDockColor(order.dock)
                            : undefined
                    }
                >
                    <span className={TableStyle.GetStatusClasses(order)}>
                        {order.dock}
                    </span>
                </td>
                <td
                    className="order-number-column"
                    style={{ fontWeight: "bold", fontSize: "1.03em" }}
                >
                    {`${order.order_no} ${order.order_group} ${order.pro_f}`}
                </td>
                {display === "Outgoing" && (
                    <td
                        className={`trailer-number-column` + (order.name == 0 ? "cred" : "")}
                    >
                        {order.bus}
                        {order.driver ? " / " + order.driver : ""}
                        {order.trailer_number && (
                            <span
                                className="text-danger text-uppercase font-weight-bold"
                            >
                                {` | ${order.trailer_number}`}
                            </span>
                        )}
                    </td>
                )}
                <td
                    className="deliver-to-column"
                    style={{ fontWeight: "bold", fontSize: "1.03em" }}
                >
                    <div>
                        <div style={{ width: '100%' }} className="d-flex justify-content-between">
                            <div className="flex-column">
                                {order.delivery_city_state}

                            </div>
                            {
                                (WasOrderLinePartialized(order))
                                    ? (
                                        <PartialTypeRowSignal />
                                    )
                                    : <></>
                            }
                        </div>
                    </div>
                </td>
                {display === "Outgoing" ? (
                    <td
                        className="scheduled-pickup-column"
                        style={scheduledPickupColor(order.pickup_date)}
                    >
                        {order.pickup_date
                            ? makeNiceDate(order.pickup_date)
                            : ""}
                    </td>
                ) : (
                    <></>
                )}
                <td
                    className="skid-column"
                >
                    {
                        WasOrderLinePartialized(order) ? (
                            <>
                                {order.units_at_terminal} / {order.units}
                            </>
                        ) : (
                            <>{order.units}</>
                        )
                    }
                    {
                        (order.is_inventory_correct) == null ? (
                            <></>
                        ) : order.is_inventory_correct ? (
                            <>
                                <i
                                    className='fa fa-check'
                                    style={{ color: "green" }}
                                />
                            </>
                        ) : ( // loaded count doesnt match units in order
                            <i
                                className='fa fa-exclamation'
                                style={{ color: "red" }}
                            />
                        )
                    }
                </td>
                <td
                    className="weight-column"
                >
                    {order.weight}
                </td>
                <td
                    className={`actions-column-${display.toLowerCase()}`}
                >
                    <>
                        {display === "Outgoing" && (
                            <>
                                <BOLPrinter order={order} />
                                {/* <button
                                    className='btn btn-primary m-1 px-2 py-1'
                                    onClick={(e) => scanQRCode(e, row.id, dispatch)}
                                    title='Scan QR'
                                >
                                    <i className='fa fa-qrcode' />
                                </button> */}
                                <InventoryScanner order={order} />
                            </>
                        )}
                        <LabelPrinter orders={[order]} />

                        {/* {row.inbound && (
                                <button
                                    className='btn btn-primary m-1 px-2 py-1'
                                    onClick={(e) =>
                                        launchCameraModal(e, row, display, dispatch)
                                    }
                                    title='Take Photo'
                                >
                                    <i className='fa fa-camera' />
                                </button>
                            )} */}
                    </>
                    {
                        !order.outgoing_bus
                            && (
                                (!order.bus || isOrderAPartialableByBusNamingConvention(order))
                            )
                            && display === "Outgoing"
                            ? (
                                <>
                                    <button
                                        className='btn btn-primary m-1 px-2 py-1'
                                        onClick={() => {
                                            dispatch(
                                                setShowReduxModal({
                                                    partialCreator: {
                                                        orderId: order.id,
                                                        showModal: true,
                                                    },
                                                })
                                            );
                                        }}
                                        disabled={!order.unloaded}
                                    >
                                        P
                                    </button>
                                </>
                            ) :
                            (

                                ((display=='Outgoing' && !order.outgoing_bus) || (display=='Incoming' && !order.incoming_bus)) && (
                                    <>
                                        <OrderLoadUnloadUtility order={order} />
                                    </>
                                )
                            )}
                </td>
                <td className="notes-column">
                    <OrderNotes order={order} />
                </td>
            </tr >
        </>
    )
}

export default OrderRow
